import React, { useState } from "react";
import fordStyles from "./SubNav.module.scss";
import lincolnStyles from "./SubNav-Lincoln.module.scss";
import { Tabs, Tab, MenuItem, Popover } from "@mui/material";
import subNavFordStyles from "./subNavStyles";
import subNavLincolnStyles from "./subNavStyles-Lincoln";
import { withTranslation } from "react-i18next";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";

const SubNavTabs = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopOverClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopOverClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event) => {
    handlePopOverClose();
    props.action(event, event.currentTarget.value);
  };

  const styles = props.isFordBrand ? fordStyles : lincolnStyles;
  const subNavStyles = props.isFordBrand
    ? subNavFordStyles
    : subNavLincolnStyles;
  const open = Boolean(anchorEl);
  const arrow = {
    position: "absolute",
    paddingTop: "1px",
    display: "inline-block",
  };

  const getStyle = (item, index) => {
    if (item.hide) {
      return subNavStyles.hide;
    } else if (item.disabledStyle) {
      return subNavStyles.disabledTab;
    } else if (!item.enabled) {
      return subNavStyles.disabledTab;
    } else if (props.selectedTab === index) {
      return subNavStyles.highlighted;
    } else {
      return subNavStyles.tab;
    }
  };

  return (
    <div className={styles.rootNav}>
      {props.tabs && !props.customSubNavTabBody && (
        <>
          <Tabs
            id="tabs"
            data-testid="tabs"
            value={
              props.selectedTab < props.visibleTabsCount
                ? props.selectedTab
                : false
            }
            onChange={props.action}
            TabIndicatorProps={{ style: subNavStyles.highlighted }}
            textColor="primary"
            variant={props.visibleTabsCount === 100 ? "scrollable" : "standard"}
            scrollButtons={false}
            classes={{
              flexContainer: styles.flexContainer,
              scrollable: styles.scrollable,
            }}
          >
            {props.tabs.map((item, index) => {
              return (
                index < props.visibleTabsCount && (
                  <Tab
                    style={getStyle(item, index)}
                    id={"tab" + item.id}
                    key={index}
                    value={index}
                    data-testid={"tab" + item.id}
                    label={item.menuName}
                    disabled={!item.enabled}
                  />
                )
              );
            })}
          </Tabs>
          {props.tabs.length > props.visibleTabsCount && (
            <>
              <div
                data-testid="moreTab"
                onClick={handlePopOverClick}
                onMouseEnter={handlePopOverClick}
                className={styles.moreTab}
                style={
                  props.selectedTab >= props.visibleTabsCount
                    ? subNavStyles.highlighted
                    : subNavStyles.tab
                }
              >
                <span>
                  {props.t("SubNav.more")}
                  {anchorEl === null ? (
                    <KeyboardArrowDown style={arrow} />
                  ) : (
                    <KeyboardArrowUp style={arrow} />
                  )}
                </span>
              </div>

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopOverClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                id="subNavMenuDropdown"
                PaperProps={{ square: true }}
              >
                {props.tabs.map((item, index) => {
                  return (
                    index >= props.visibleTabsCount && (
                      <MenuItem
                        onClick={handleMenuItemClick}
                        value={index}
                        key={index}
                        data-testid={"tab" + item.id}
                        id={"tab" + item.id}
                        style={
                          item.hide
                            ? subNavStyles.hide
                            : props.selectedTab === index
                            ? subNavStyles.highlightedMenuItem
                            : subNavStyles.menuItem
                        }
                        disabled={!item.enabled}
                      >
                        {item.menuName}
                      </MenuItem>
                    )
                  );
                })}
              </Popover>
            </>
          )}
        </>
      )}
      {props.customSubNavTabBody && (
        <props.customSubNavTabBody></props.customSubNavTabBody>
      )}
    </div>
  );
};

export default withTranslation("emp")(SubNavTabs);
